module.exports = [{
      plugin: require('/builds/smamudhan/soul-journal/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/builds/smamudhan/soul-journal/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
